/**
 * Luminary logo — beacon mark.
 * A lighthouse/compass-style "L+I" with a gold beam,
 * conveying guidance, foresight, and intelligence.
 */
export function LogoMark({ size = 32, color = "currentColor", beam = "#C9A227" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* outer square (signal frame) */}
      <rect x="1.5" y="1.5" width="45" height="45" stroke={color} strokeWidth="1.5" fill="none" />
      {/* upright L */}
      <path d="M14 10 V32 H30" stroke={color} strokeWidth="2.5" strokeLinecap="square" />
      {/* dot — the beacon */}
      <circle cx="32" cy="14" r="2.7" fill={beam} />
      {/* beam rays */}
      <path d="M32 6 V11" stroke={beam} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M38 10 L34.5 12.5" stroke={beam} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M40 16 L36.5 16" stroke={beam} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ size = "md", inverse = false, withWordmark = true }) {
  const sizes = { sm: 22, md: 28, lg: 36, xl: 48 };
  const px = sizes[size] || 28;
  const text = inverse ? "#FFFFFF" : "#0F172A";
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={px} color={text} beam="#C9A227" />
      {withWordmark && (
        <div className="leading-none">
          <div
            className="font-display font-black tracking-tight"
            style={{
              fontSize: size === "xl" ? 28 : size === "lg" ? 22 : 18,
              color: text,
              lineHeight: 1,
            }}
          >
            LUMINARY
          </div>
          <div
            className="font-mono uppercase mt-1"
            style={{
              fontSize: 9,
              letterSpacing: "0.24em",
              color: inverse ? "rgba(255,255,255,0.6)" : "var(--slate-light)",
            }}
          >
            Insights &amp; Advisory
          </div>
        </div>
      )}
    </div>
  );
}
